export const environment = {
  production: true,
  BASE_DOMAIN:'https://pms.apollosupplychain.com/',
  New_BASE_DOMAIN:'https://pms.apollosupplychain.com/',
  COOKIE_DOMAIN: 'localhost',
  ORDER_URL: 'https://pms.apollosupplychain.com/',
  WebsocketUrl: 'wss://pms.apollosupplychain.com/websocket-service/ws/notifications'
};
